import React from 'react';
import PropTypes from 'prop-types';
import MContactInfoFooter from '../molecules/contact/_molecules.contact-info-footer';
import MNavigationFooter from '../molecules/navigation/_molecule.navigation-footer';
import MSocialMedia from '../molecules/social-media/_molecules.social-media';

export default function OFooter({ theme }) {
	return (
		<footer className="o-footer">
			<section className="o-footer--top">
				<MContactInfoFooter />
				<div className="wrapper">
					<MNavigationFooter theme={theme} />
				</div>
				<MSocialMedia type="white" className="o-footer--social-media" />
			</section>

			<section className="o-footer--bottom">
				<p className="small-link">copyrighted {new Date().getFullYear()} |
					<a href="https://www.gentwebart.be/" className="a-button--ghost"> made by Gentwebart</a>
				</p>
			</section>
		</footer>
	);
}

OFooter.propTypes = {
	theme: PropTypes.string,
};

OFooter.defaultProps = {
	theme: undefined,
};



// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.footer.js